/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class ShipmentState {
  canModifyShipmentDriverAndVehicle = false;
  canCreateTaskFromRouting = false;
}
